<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M21 4v2h-1l-6 9v7h-4v-7L4 6H3V4h18z"/></svg></template>